import { i18nClient } from '@sailor/i18n-mach-pro/lib';
import { GoodDetailParam } from '../../../../pages/shop/c_shop_golden/component';
import { CommonHeaders } from '../../../../pages/shop/c_shop_golden/utils/commonHeaders';
import { MULTI_SKU_ERROR_CODE, SHOPURL } from '../../../../pages/shop/c_shop_golden/utils/constant';

const Dialog = Mach.requireModule('Dialog');

export async function ValidationRequest(requestParam: GoodDetailParam, btnText: string, headers = {}, func?: Function): Promise<any> {
  // @ts-ignore
  const networkModule = Mach.requireModule('Network');
  const params = {
    url: SHOPURL.MULTISKUVALIDATION,
    method: 'POST',
    dataType: 'json',
    data: requestParam,
    headers: {
      ...CommonHeaders.getCommonHeader(),
      ...headers
    }
  };

  // @ts-ignore
  const indicatorModule = Mach.requireModule('ActivityIndicator');
  indicatorModule.showLoading();
  return new Promise<any>((resolve, reject) => {
    networkModule.requestWx(params, (result: any) => {
      //todo：看下这块Native的网络请求逻辑
      indicatorModule.hideLoading();
      if (result.error) {
        console.log(`PreCheck request api error: ${JSON.stringify(result.error)}`);
        reject(result.error);
      } else {
        console.log('PreCheck request api success!');
        if (result.data && result.data.code === 0 && result.data.data) {
          resolve(result.data.data);
        } else if (result.data && result.data.code === MULTI_SKU_ERROR_CODE.STYSTEMERROR) {
          // 校验接口系统异常
          reject(result.data);
        } else {
          const errMsg = result.data.message || i18nClient.getText('shouye_default_4');
          Dialog?.show({
            title: errMsg,
            rightButtonTitle: btnText,
          }, (result: any) => {
            if (result.which === -1 && func) {
              func(params.data.spuId);
            }
          });
          reject(errMsg);
        }
      }
    });
  });
}
